import React from "react";
import TopSuppliersTable from "../../components/Report/TopSuppliersTable";

const ReportTopSuppliersPage: React.FC = () => <TopSuppliersTable />;
export default ReportTopSuppliersPage;
